export const IconIndustry = ({
  width = 35,
  height = 24,
  color = 'white',
  rotation = 0,
}) => (
  <svg
    width='26'
    height='26'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.03075 25.3077L6.80508 21.5541L2.56942 20.6411L2.98475 16.2717L0.128418 13L2.98475 9.72838L2.56942 5.35905L6.80508 4.44605L9.03075 0.692383L13.0001 2.36938L16.9694 0.692383L19.1951 4.44605L23.4308 5.35905L23.0154 9.72838L25.8718 13L23.0154 16.2717L23.4308 20.6411L19.1951 21.5541L16.9694 25.3077L13.0001 23.6307L9.03075 25.3077ZM9.60008 23.6001L13.0001 22.1847L16.4154 23.6001L18.3334 20.4001L22.0001 19.5847L21.6668 15.8001L24.1334 13L21.6668 10.1847L22.0001 6.40005L18.3334 5.60005L16.4001 2.40005L13.0001 3.81538L9.58475 2.40005L7.66675 5.60005L4.00008 6.40005L4.33342 10.1847L1.86675 13L4.33342 15.8001L4.00008 19.6001L7.66675 20.4001L9.60008 23.6001ZM11.6001 16.8104L18.2104 10.2001L17.2668 9.24105L11.6001 14.9077L8.73342 12.0564L7.78975 13L11.6001 16.8104Z'
      fill='#121926'
    />
  </svg>
);
